"use client";

import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@/components/ui/button";
import { getMoreProductsAPI } from "@/clientSideApi/catalog";
import { useSearchParams } from "next/navigation";
import { convertSearchParamsToString } from "@/lib/utils";
import {
  setCatalogDataNext,
  setCurrentPage,
} from "@/store/catalog/catalogSlice";
import { Line } from "@/components/CustomUI/modules/Loaders";

const LoadMore = ({ categorySlug }) => {

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const searchParams = useSearchParams();
  const currentPage = useSelector((state) => state.catalog.currentPage);
  const last_page = useSelector((state) => state.catalog.data?.meta?.last_page);

  const createQueryString = useCallback(
    (value) => convertSearchParamsToString(searchParams, "page", value),
    [searchParams]
  );

  const handleLoadMoreData = async () => {
    if (loading) return;
    setLoading(true);
    const searchUrl = createQueryString(currentPage + 1);
    const apiResponse = await getMoreProductsAPI(categorySlug, searchUrl);
    if (apiResponse) {
      dispatch(setCatalogDataNext(apiResponse));
      dispatch(setCurrentPage(currentPage + 1));
    }
    setLoading(false);
  };

  if (!last_page || currentPage >= last_page) return null;

  return (
    <div className="flex w-full pt-3 justify-center">
      <Button
        aria-label="load more data"
        variant="outline"
        className="
          h-[33px] text-xs md:text-sm 
          mt-4 px-[30px] relative hover:drop-shadow-sm
        "
        onClick={handleLoadMoreData}
      >
        <span className="mr-1">Load More</span>
        <Line 
          loading={loading} 
          classes={"absolute right-0"}
        />
      </Button>
    </div>
  );
};

export default LoadMore;
